import each from './each';
export default each;
//# sourceMappingURL=for-in.js.map